//Helpers
import { debug }    from './theme/helpers/debug.js';
import { helpers }  from './theme/helpers/helpers.js';
import { fix100vh } from './theme/helpers/fix100vh.js';

//Utilities
import { parallax }        from './theme/components/utilities/parallax.js';
import { smoothScroll }    from './theme/components/utilities/smooth-scroll.js';
import { viewportChecker } from './theme/components/utilities/viewport-checker.js';

//Global components
import { lightbox }         from './theme/components/global/lightbox.js';
import { stickyNavigation } from './theme/components/global/sticky-navigation.js';
import { searchForm }       from './theme/components/global/search-form.js';
import { mobileNavigation } from './theme/components/global/mobile-navigation.js';
import { modal }            from './theme/components/global/modal.js';
import { tabs }             from './theme/components/global/tabs.js';
import { mapbox }           from './theme/components/global/mapbox.js';
import { langSwitcher }     from './theme/components/global/lang-switcher.js';

//Template components
import { carousel }         from './theme/components/template/carousel.js';
import { serviceCarousel }  from './theme/components/template/service-carousel.js';
import { shopNavigation }   from './theme/components/template/shop-navigation.js';

//Shop
import { cart } from './theme/components/shop/cart.js';
import { filters } from './theme/components/shop/filters.js';
import { productGallery } from './theme/components/shop/product-gallery.js';

window.theme = {

    globals: {
        enablePjax: false,
        disableClick: false,
        isTouch: typeof window !== "undefined" && "ontouchstart" in window
    },

    init: function() {
        var theme = this;

        if ( theme.globals.isTouch === true ) {
            $( document.body ).addClass( 'touch-device' );
        } else {
            $( document.body ).addClass( 'pointer-device' );
        }

        //Fixes
        fix100vh.init();

        //Utilities
        parallax.init();
        smoothScroll.init();
        viewportChecker.init();

        //Global
        lightbox.init();
        stickyNavigation.init();
        searchForm.init();
        mobileNavigation.init();
        modal.init();
        tabs.init();

        //Content
        theme.content.init();

        //Global
        mapbox.init();
        langSwitcher.init();

        //Template
        carousel.init();
        serviceCarousel.init();
        shopNavigation.init();

        //Shop
        cart.init();
        filters.init();
        productGallery.init();
    },

    content: {
        init: function() {
            //Global
            theme.imagesLoaded.init();
            //theme.responsiveBackgroundImage.init();
            theme.variationForm.init();

            //Shop related
            theme.checkout.init();
        }
    },
    
    imagesLoaded: {
        init: function() {
            $( '#site' ).imagesLoaded( {
                background: true
            }, function() {
                $( document.body ).addClass( 'loaded' );
            } );
        }
    },

    responsiveBackgroundImage: {
        selector: '*[data-mobile-background-image]',
        init: function() {
            var self = this,
                $elements = $( self.selector ),
                viewportWidth = $( window ).width();

            $elements.each( function() {
                var $element = $( this ),
                    mobileBackgroundImageUrl = $element.attr( 'data-mobile-background-image' );

                if ( viewportWidth <= 768 ) {
                    $element.css( 'background-image', 'url("' + mobileBackgroundImageUrl + '")' );
                }
            } );
        }
    },
    
    variationForm: {
        selector: 'form.variations_form',
        init: function() {
            var self = this;

            $( self.selector ).on( 'show_variation', function( e, variation ) {
                var $this = $( this );

                $this.find( 'select' ).trigger( 'refresh' );
            } );
        }
    },

    checkout: {
        init: function() {
            $( document.body ).on( 'update_checkout', function() {
                $( document.body ).addClass( 'updating-checkout' );
            } );

            $( 'form.checkout' ).on( 'click', 'input[name^="shipping_method"]', function( e ) {
                if ( $( '.shipping-methods input.shipping_method' ).length > 1 ) {
                    var target_shipping_method_info = $( 'div.shipping_method_info.' + $( this ).attr( 'ID' ) ),
                        is_checked                  = $( this ).is( ':checked' );

                    if ( is_checked && ! target_shipping_method_info.is( ':visible' ) ) {
                        $( 'div.shipping_method_info' ).filter( ':visible' ).slideUp( 230 );

                        if ( is_checked ) {
                            target_shipping_method_info.slideDown( 230 );
                        }
                    }
                } else {
                    $( 'div.shipping_method_info' ).show();
                }
            } );

            $( document.body ).on( 'updated_checkout', function() {
                $( document.body ).removeClass( 'updating-checkout' );
            } );

            $( document.body ).on( 'after_opc_add_remove_product', function( e, data, response ) {
                if ( $.isEmptyObject( response.products_in_cart ) ) {
                    window.location.reload( false );
                }
            } );

            this.mimicCoupon();
        },
        mimicCoupon: function() {
            var $checkout = $( '.checkout' );

            $checkout.on( 'keyup', 'input[name="mimic_coupon_code"]', function() {
                var $this = $( this ),
                    $couponInput = $( 'input[name="coupon_code"]' );
                $couponInput.val( $this.val() );

                console.log( $this.val() );
            } );

            $checkout.on( 'click', 'button[name="mimic_apply_coupon"]', function( e ) {
                e.preventDefault();

                $( 'button[name="apply_coupon"]' ).trigger( 'click' );
            } );
        }
    }
    
}

jQuery( document ).ready( function( $ ) {
    theme.init();
} );
